(function () {
  'use strict';

  var markets = {
    US: { country: 'United States', language: 'English', locale: 'en', currency: '$ USD' },
    AR: { country: 'Argentina', language: 'Español', locale: 'es', currency: '$ ARS' },
    AU: { country: 'Australia', language: 'English', locale: 'en', currency: '$ AUD' },
    NZ: { country: 'New Zealand', language: 'English', locale: 'en', currency: '$ NZD' }
  };

  var regions = [
    { title: 'North America', countries: ['US'] },
    { title: 'South America', countries: ['AR'] },
    { title: 'Asia Pacific', countries: ['AU', 'NZ'] }
  ];

  var enhancedSwitcher = null;
  var mobileMedia = window.matchMedia('(max-width: 999px)');

  function addGlobeIcon(root) {
    var selection = root.querySelector('.tl-selection.tl-currency');
    var flag = selection && selection.querySelector('.tl-flag');

    if (!selection || selection.querySelector('.tl-market-globe')) {
      return;
    }

    if (flag) {
      flag.remove();
    }

    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', 'tl-market-globe');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('width', '18');
    icon.setAttribute('height', '18');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<circle cx="12" cy="12" r="9"></circle><path d="M3 12h18M12 3c2.3 2.5 3.5 5.5 3.5 9s-1.2 6.5-3.5 9c-2.3-2.5-3.5-5.5-3.5-9S9.7 5.5 12 3Z"></path>';
    selection.insertBefore(icon, selection.firstChild);
  }

  function placeSwitcher() {
    if (!enhancedSwitcher || !document.documentElement.contains(enhancedSwitcher)) {
      return;
    }

    var slotName = mobileMedia.matches ? 'mobile' : 'desktop';
    var slot = document.querySelector('[data-market-switcher-slot="' + slotName + '"]');

    if (slot && enhancedSwitcher.parentNode !== slot) {
      slot.appendChild(enhancedSwitcher);
    }
  }

  function enhanceSwitcher(root) {
    if (!root || root.dataset.marketEnhanced === 'true') {
      return;
    }

    var currencySelect = root.querySelector('.tl-currency-select');
    var currencyOptions = currencySelect && currencySelect.nextElementSibling;
    var currencyForm = currencySelect && currencySelect.closest('form');
    var countryInput = currencyForm && currencyForm.querySelector('[name="country_code"]');
    var languageInput = currencyForm && currencyForm.querySelector('[name="language_code"]');

    if (!currencyOptions || !countryInput || !languageInput) {
      return;
    }

    root.dataset.marketEnhanced = 'true';
    root.classList.add('tl-market-enhanced');
    enhancedSwitcher = root;

    var trigger = root.querySelector('.tl-selections');
    var triggerLabel = root.querySelector('.tl-selection.tl-currency .tl-label');
    var currentMarket = markets[countryInput.value] || markets.US;

    if (trigger && triggerLabel) {
      triggerLabel.textContent = currentMarket.country + ' (' + currentMarket.language + ' / ' + currentMarket.currency + ')';
      triggerLabel.dataset.mobileLabel = countryInput.value + ' · ' + currentMarket.locale.toUpperCase() + ' · ' + currentMarket.currency.replace('$ ', '');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-label', 'Change country or region. Current selection: ' + triggerLabel.textContent);
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    }

    addGlobeIcon(root);

    var overlay = root.querySelector('.tl-overlay');
    if (overlay) {
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Select country or region');
    }

    var titles = root.querySelectorAll('.tl-overlay .tl-title');
    if (titles[0]) {
      titles[0].textContent = 'Select your Country/Region';

      if (!root.querySelector('.tl-market-dialog-description')) {
        var description = document.createElement('p');
        description.className = 'tl-market-dialog-description';
        description.textContent = 'Products may have different prices and availability based on country/region.';
        titles[0].insertAdjacentElement('afterend', description);
      }
    }
    if (titles[1]) {
      titles[1].classList.add('tl-market-language-title');
      if (titles[1].nextElementSibling) {
        titles[1].nextElementSibling.classList.add('tl-market-language-switcher');
      }
    }

    var optionMap = {};
    Array.prototype.forEach.call(currencyOptions.querySelectorAll('.tl-option[data-value]'), function (option) {
      optionMap[option.dataset.value] = option;
    });

    var grid = document.createElement('div');
    grid.className = 'tl-market-grid';

    regions.forEach(function (region) {
      var section = document.createElement('section');
      var heading = document.createElement('h3');
      var list = document.createElement('ul');

      section.className = 'tl-market-region';
      heading.className = 'tl-market-region-title';
      heading.textContent = region.title;
      list.className = 'tl-market-options';
      list.setAttribute('role', 'list');

      region.countries.forEach(function (countryCode) {
        var option = optionMap[countryCode];
        var market = markets[countryCode];

        if (!option || !market) {
          return;
        }

        var oldLabel = option.querySelector('.tl-label');
        var copy = document.createElement('span');
        var country = document.createElement('span');
        var meta = document.createElement('span');

        if (oldLabel) {
          oldLabel.remove();
        }

        copy.className = 'tl-market-option-copy';
        country.textContent = market.country;
        meta.className = 'tl-market-option-meta';
        meta.textContent = market.language + ' / ' + market.currency;
        copy.appendChild(country);
        copy.appendChild(meta);
        option.appendChild(copy);
        option.setAttribute('tabindex', '0');
        option.setAttribute('aria-label', market.country + ', ' + market.language + ', ' + market.currency);
        list.appendChild(option);
      });

      section.appendChild(heading);
      section.appendChild(list);
      grid.appendChild(section);
    });

    currencyOptions.parentNode.insertBefore(grid, currencyOptions.nextSibling);

    grid.addEventListener('click', function (event) {
      var option = event.target.closest('.tl-option[data-value]');
      var market = option && markets[option.dataset.value];

      if (market) {
        event.preventDefault();
        event.stopPropagation();
        countryInput.value = option.dataset.value;
        languageInput.value = market.locale;
        currencyForm.submit();
      }
    }, true);

    grid.addEventListener('keydown', function (event) {
      var option = event.target.closest('.tl-option[data-value]');
      if (option && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        option.click();
      }
    });

    placeSwitcher();
  }

  function enhanceAll() {
    document.querySelectorAll('.tl-switcher-container:not(.hidden)').forEach(enhanceSwitcher);
  }

  document.addEventListener('tlSwitcherReady', enhanceAll);
  mobileMedia.addEventListener('change', placeSwitcher);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }

  new MutationObserver(enhanceAll).observe(document.documentElement, { childList: true, subtree: true });
})();
